import { render, staticRenderFns } from "./customer_data_report.vue?vue&type=template&id=ff149cb4&scoped=true"
import script from "./customer_data_report.vue?vue&type=script&lang=js"
export * from "./customer_data_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff149cb4",
  null
  
)

export default component.exports